import { get, put, postAttachmentData, post, remove } from './mainApi';
import { generateId } from 'src/utils/traceIdGenerations';

const leaveServiceBaseURL = process.env.REACT_APP_LEAVE_MANAGEMENT_ENDPOINT;

const employeeServiceURL = process.env.REACT_APP_EMPLOYEE_MANAGEMENT_ENDPOINT;

const leaveBalanceBaseURL = process.env.REACT_APP_LEAVE_BALANCE_ENDPOINT;

const leaveManagementV1LeaveBalanceURL = process.env.REACT_APP_LEAVE_MANAGEMENT_V1_LEAVE_BALANCE_ENDPOINT;

const leaveManagementV1ServiceURL = process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT;

const leaveEligibilityBaseURL =
  process.env.REACT_APP_LEAVE_ELIGIBILITY_ENDPOINT;

const withTraceId = (url: string) => {
  const traceId = generateId(9);
  return url.includes('?')
    ? `${url}&traceId=${traceId}`
    : `${url}?traceId=${traceId}`;
};

export const applyLeave = async (data: FormData, employmentType: String) => {
  const response = postAttachmentData(
    withTraceId(
      `${leaveServiceBaseURL}save?employment-type=${employmentType}`
    ),
    data
  );
  return response;
};

export const applyLieuLeave = async (data) => {
  const response = post(withTraceId(`${leaveServiceBaseURL}lieu-leave`), data);
  return response;
};

export const getDayCount = async (startDate, endDate) => {
  const response = get(
    withTraceId(
      `${leaveServiceBaseURL}days-count?start_date=${startDate}&end_date=${endDate}`
    )
  );
  return response;
};

export const getLieuLeaveDayCount = async (startDate, endDate) => {
  const response = get(
    withTraceId(
      `${leaveServiceBaseURL}lieu-leave-days-count?start_date=${startDate}&end_date=${endDate}`
    )
  );
  return response;
};

export const getLeaveTypeList = async (gender, employmentType) => {
  const response = get(
    withTraceId(
      `${leaveServiceBaseURL}dropdown-values?gender=${gender}&employment_type=${employmentType}`
    )
  );
  return response;
};

export const getLeaveList = async (
  status,
  pageNo,
  pageSize,
  userRole,
  reporterId,
  isReportingManager
) => {
  const response = get(
    withTraceId(
      `${leaveServiceBaseURL}leave-requests?status=${status}&page=${pageNo}&size=${pageSize}&reporting_manager_id=${
        isReportingManager ? reporterId : ''
      }&role=${userRole}`
    )
  );
  return response;
};

export const approveLieuLeave = async (requestId, employmentType) => {
  const response = put(
    withTraceId(
      `${leaveEligibilityBaseURL}approve/${requestId}?employment-type=${employmentType}`
    ),
    []
  );
  return response;
};

export const rejectLieuLeave = async (requestId, data, employmentType) => {
  const response = put(
    withTraceId(
      `${leaveEligibilityBaseURL}reject/${requestId}?employment-type=${employmentType}`
    ),
    data
  );
  return response;
};

export const getReportingEmployee = async (employeeId) => {
  const response = get(
    withTraceId(
      `${employeeServiceURL}reporting-employee?employeeId=${employeeId}`
    )
  );
  return response;
};

export const getLeaveCount = async (employeeId) => {
  const response = get(
    withTraceId(`${leaveBalanceBaseURL}employee/${employeeId}`)
  );
  return response;
};

export const initiateLeaveTypes = async (data) => {
  const response = put(
    withTraceId(`${leaveBalanceBaseURL}initiate-by-leave-type`),
    data
  );
  return response;
};

export const filteredDropdownList = async (pageNo, pageSize, status, role) => {
  const response = get(
    withTraceId(
      `${leaveServiceBaseURL}tab-dropdown-values?pageSize=${pageSize}&pageNo=${pageNo}&role=${role}&status=${status}`
    )
  );
  return response;
};

export const getLeaveHistory = async (empId: string) => {
  const response = get(
    withTraceId(`${leaveServiceBaseURL}view-history/${empId}`)
  );
  return response;
};

export const searchLeaveHistory = async (keyWord: string, empId: string) => {
  const response = get(
    withTraceId(
      `${leaveServiceBaseURL}search-history/${empId}?keyword=${keyWord}`
    )
  );
  return response;
};

export const cancelLeave = async (requestId, employmentType, data) => {
  const response = put(
    withTraceId(
      `${leaveServiceBaseURL}cancel/${requestId}?employment-type=${employmentType}`
    ),
    data
  );
  return response;
};

export const approveCancelLeave = async (requestId, employmentType, loggedUser) => {
  const response = put(
    withTraceId(
      `${leaveServiceBaseURL}cancel/approve/${requestId}?employment-type=${employmentType}&approved-user-name=${loggedUser}`
    ),
    []
  );
  return response;
};

export const rejectCancelLeave = async (
  requestId,
  data,
  loggedUser,
  employmentType
) => {
  const response = put(
    withTraceId(
      `${leaveServiceBaseURL}cancel/reject/${requestId}?employment-type=${employmentType}&rejected-user-name=${loggedUser}`
    ),
    data
  );
  return response;
};

export const filterLeaveHistory = async (empId, optionalData) => {
  let newUrl = `${leaveServiceBaseURL}filter-leave-history?employeeId=${empId}`;

  if (optionalData.fromDate) {
    newUrl += `&fromDate=${optionalData.fromDate}`;
  }
  if (optionalData.toDate) {
    newUrl += `&toDate=${optionalData.toDate}`;
  }
  if (optionalData.status) {
    newUrl += `&status=${optionalData.status}`;
  }
  if (optionalData.leaveType) {
    newUrl += `&typeName=${optionalData.leaveType}`;
  }

  const response = get(withTraceId(newUrl));
  return response;
};

export const getMainLeaveList = async (
  status,
  pageNo,
  pageSize,
  filter,
  isEligible
) => {
  let newUrl = `${leaveServiceBaseURL}search?pageSize=${pageSize}&pageNo=${pageNo}&status=${status}&isEligible=${isEligible}`;
  if (filter) {
    newUrl += `&filter=${filter}`;
  }
  const response = get(withTraceId(newUrl));
  return response;
};

export const getOnLeaveList = async (
  userRole,
  reporterId,
  isReportingManager
) => {
  const response = get(
    withTraceId(
      `${leaveServiceBaseURL}employees-on-leave?reporting-manager-id=${
        isReportingManager ? reporterId : ''
      }&role=${userRole}`
    )
  );
  return response;
};

export const getLeaveHistoryById = async (leaveRequestId: string) => {
  const response = get(
    withTraceId(`${leaveServiceBaseURL}${leaveRequestId}`)
  );
  return response;
};

export const getAssignedRequests = async (
  status,
  pageNo,
  pageSize,
  userRole,
  isEligible,
  leaveType,
  hrApproved,
  filter,
  isLeaveCountRequired
) => {
  let newUrl = `${leaveServiceBaseURL}assigned?pageSize=${pageSize}&pageNo=${pageNo}&status=${status}&role=${userRole}`;

  if (isEligible !== null) {
    newUrl += `&isEligible=${isEligible}`;
  }
  if (leaveType) {
    newUrl += `&leaveType=${leaveType}`;
  }
  if (hrApproved) {
    newUrl += `&hrApproved=${hrApproved}`;
  }
  if (filter) {
    newUrl += `&filter=${filter}`;
  }
  if (isLeaveCountRequired) {
    newUrl += `&isLeaveCountRequired=${isLeaveCountRequired}`;
  }
  const response = get(withTraceId(newUrl));
  return response;
};

export const approveLeave = async (requestId, employmentType, loggedUser) => {
  const response = put(
    withTraceId(
      `${leaveServiceBaseURL}approve/${requestId}?employment-type=${employmentType}&approved-user-name=${loggedUser}`
    ),
    []
  );
  return response;
};

export const rejectLeave = async (
  requestId,
  data,
  loggedUser,
  employmentType
) => {
  const response = put(
    withTraceId(
      `${leaveServiceBaseURL}reject/${requestId}?employment-type=${employmentType}&rejected-user-name=${loggedUser}`
    ),
    data
  );
  return response;
};

export const getCalenderDataByEmployeeId = async (employeeId) => {
  const response = get(
    withTraceId(`${leaveServiceBaseURL}approved/${employeeId}`)
  );
  return response;
};

export const getEmployeeLeaves = async (role: any, pageSize: number, pageNo: number, filter?: any, sort?: any) => {
  let newUrl = `${leaveManagementV1LeaveBalanceURL}employee-leaves?role=${role}&pageSize=${pageSize}&pageNo=${pageNo}`;
  if (filter) {
    newUrl += `&filter=${filter}`;
  }
  if (sort) {
    newUrl += `&sort=${sort}`;
  }
  const response = get(withTraceId(newUrl));
  return response;
};

export const downloadExcel = async (role: any, filter?: any, sort?: any) => {
  let newUrl = `${leaveManagementV1LeaveBalanceURL}download-employee-leaves?role=${role}`;
  if (filter) {
    newUrl += `&filter=${filter}`;
  }
  if (sort) {
    newUrl += `&sort=${sort}`;
  }
  const response = get(withTraceId(newUrl), 'arraybuffer');
  return response;
};

export const getEmployeeLeaveForSelectedMonth = async (empId:any,month: number, year: number) => {
  var response = get(
    withTraceId(
      `${leaveManagementV1ServiceURL}leave-request/user-leave-summery/${empId}/${year}/${month}`
    )
  );
  return response;
};


export const applyWfh = async (data: FormData, employmentType: String) => {
  const response = postAttachmentData(
    withTraceId(
      `${leaveServiceBaseURL}save/work-from-home?employment-type=${employmentType}`
    ),
    data
  );
  return response;
};


export const getWorkModelConfigurations = async (data: any, offset:number, limit:number) => {
  const response = post(
    withTraceId(
      `${leaveManagementV1ServiceURL}work-from-home/configuration-summery?pageSize=${limit}&pageNo=${offset}`
    ),
    data
  );
  return response;
};

export const getAllWorkFromHomeRequests = async (data: any, offset:number, limit:number) => {
  const response = post(
    withTraceId(
      `${leaveManagementV1ServiceURL}work-from-home/request-summery?pageSize=${limit}&pageNo=${offset}`
    ),
    data
  );
  return response;
};

export const configureWorkModel = async (data) => {
  const response = post(
    withTraceId(
      `${leaveManagementV1ServiceURL}work-from-home/configuration-save`
    ),
    data
  );
  return response;
};

export const updateConfigureWorkModel = async (data) => {
  const response = put(
    withTraceId(
      `${leaveManagementV1ServiceURL}work-from-home/configuration-summery-update`
    ),
    data
  );
  return response;
};

export const deleteWorkModelById = async (id) => {
  var response = remove(
    withTraceId(
      `${leaveManagementV1ServiceURL}work-from-home/configuration-delete/${id}`
    )
  );
  return response;
};

export const workFromHomeRequest = async (data: FormData) => {
  const response = postAttachmentData(
    withTraceId(`${leaveManagementV1ServiceURL}work-from-home/request-save`),
    data
  );
  return response;
};

export const workFromHomeRequestApprovalProcess = async (data: any) => {
  const response = put(
    withTraceId(
      `${leaveManagementV1ServiceURL}work-from-home/request-approval-process`
    ),
    data
  );
  return response;
};
